import React from 'react';
import { required, Toolbar, SaveButton, SelectInput, DateField, SimpleForm, ReferenceArrayInput, ReferenceField, 
	AutocompleteArrayInput, Button, NumberInput, Edit, Create, BooleanInput, EditButton, List, Datagrid, TextField,
	TextInput, AutocompleteInput, ReferenceInput, BooleanField, sanitizeListRestProps, useListContext,
	TopToolbar, FilterButton, CreateButton, ExportButton } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';

const placementFilters = [
	<TextInput label="Search" source="search_name" alwaysOn resettable />,
	<ReferenceArrayInput source="site_id" label="Site" 
		reference="sites"
		basePath='sites'
		alwaysOn
		perPage={10}
		sort={{ field: 'name', order: 'ASC' }}
		filterToQuery={searchText => ({ search_name: searchText })}
		allowEmpty>
		<AutocompleteArrayInput label="Sites" optionText="adunit_path" optionValue="code" style={{ width: '90%' }} />
	</ReferenceArrayInput>,
	<NumberInput label="Placement ID" source="search_id" resettable />,
	<ReferenceArrayInput source="publisher_id" label="Publisher"
		reference="publishers"
		basePath='publishers'
		perPage={10}
		sort={{ field: 'name', order: 'ASC' }}
		filterToQuery={searchText => ({ search_name: searchText })}>
		<AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" style={{ width: '90%' }} />
	</ReferenceArrayInput>
];

const SiteButton = (props) => {
	var path = "/#/sites/" + props.record.site_id;
	return (
		<Button href={path} label="EDIT Site" variant="contained" color="primary" startIcon={<EditIcon />} />
	)
}

const ListActions = (props) => {
    const { className, maxResults, ...rest } = props;
    const { total } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <CreateButton />
            <ExportButton disabled={total === 0} maxResults={30000} />
        </TopToolbar>
    );
};

export const PlacementList = (props) => (
	<List {...props} filters={placementFilters} perPage={25} bulkActionButtons={false} actions={<ListActions />}>
		<Datagrid rowClick="edit">
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
			<TextField source="site_name" label="Site" />
			<TextField source="publisher_name" label="Publisher" />
			<BooleanField source="active" label="Active" />
			<EditButton variant="contained" color="primary" />
		</Datagrid>
	</List>
);

const PlacementTitle = ({ record }) => {
	return <span>Placement {record ? `"${record.name}"` : ''} {record && record.active ? 'ACTIVE' : 'INACTIVE'}</span>;
};

const siteRenderer = (choice) => {
	if (!choice || !choice.name) return;
	return `${choice.name}  (${choice.publisher_name}) (${choice.code})`;
};
const CustomToolbar = props => (
	<Toolbar {...props}>
		<SaveButton />
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
export const PlacementEdit = (props) => (
	<Edit title={<PlacementTitle />} {...props}>
		<SimpleForm toolbar={<CustomToolbar />}>
			<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
			<TextField source="code" label="Placement ID" validate={required()} />
			<TextInput source="name" label="Placement Name" style={{ width: '400px' }} validate={required()} />

			<ReferenceField label="Site" source="site_id" reference="sites">
				<TextField source="name" />
			</ReferenceField>
			<SiteButton {...props} />
			<TextField source="adunit_path" label="Ad Unit Path" defaultValue="/64387298/" style={{ width: '400px' }} validate={required()} />
			<SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
				choices={[
						{ id: 1, name: 'At 1%' },
						{ id: 10, name: 'At 10%' },
						{ id: 20, name: 'At 20%' },
						{ id: 30, name: 'At 30%' },
						{ id: 40, name: 'At 40%' },
						{ id: 50, name: 'At 50%' },
						{ id: 60, name: 'At 60%' },
						{ id: 70, name: 'At 70%' },
						{ id: 80, name: 'At 80%' },
						{ id: 90, name: 'At 90%'},
						{ id: 100, name: 'At 100%'}
				]}
			/>
		</SimpleForm>
	</Edit>
);

export const PlacementCreate = (props) => (
	<Create title={<PlacementTitle />} {...props}>
		<SimpleForm toolbar={<CustomToolbar />}>
			<BooleanInput source="active" label="Active" defaultValue={true} validate={required()} style={{ width: '10%' }} />
			<TextInput source="name" label="Placement Name" style={{ width: '400px' }} validate={required()} />
			<ReferenceInput source="site_id" label="Site" reference="sites"
				basePath='sites'
				style={{ width: '400px' }}
				perPage={200}
				validate={required()}
				sort={{ field: 'name', order: 'ASC' }}
				filterToQuery={searchText => ({ search_name: searchText })}
			>
				<AutocompleteInput label="Sites" optionText={siteRenderer} optionValue="code" style={{ width: '400px' }} />
			</ReferenceInput>
			<SelectInput label="Viewability" source="viewability" allowEmpty emptyText="- None -"
				choices={[
						{ id: 1, name:  'At 1%' },
						{ id: 10, name: 'At 10%' },
						{ id: 20, name: 'At 20%' },
						{ id: 30, name: 'At 30%' },
						{ id: 40, name: 'At 40%' },
						{ id: 50, name: 'At 50%' },
						{ id: 60, name: 'At 60%' },
						{ id: 70, name: 'At 70%' },
						{ id: 80, name: 'At 80%' },
						{ id: 90, name: 'At 90%'},
						{ id: 100, name: 'At 100%'}
				]}
			/>
		</SimpleForm>
	</Create>
);